import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

/**
* async submit（汎用）
* @param {Function | Object} opt: 成功コールバック or オプション項目（内容はソース内のdefaultsを参照）
*/
function aSubmit(opt) {
	u_.isFunction(opt) && (opt = {
		success: opt
	});
	
	let $form = this.$self;
	
	// 引数をデフォルト値とマージ
	opt = Object.assign({
		methodName: "aSubmit",
		url: $form.attr("action"),	// 空の場合はメンバ変数から取得
		type: $form.attr("method"),	// 空の場合はGET
		begin: function() {},	// @param $form, opt
		success: function() {},	// @param response
		error: function() {},	// @param error
		complete: function() {}	// @param response
	}, opt);
	
	const methodName = opt.methodName;
	delete opt.methodName;
	
	!opt.url && (delete opt.url);
	!opt.type && (delete opt.type);
	
	const callbacks = {};
	["begin", "success", "error", "complete"].forEach(k => {
		callbacks[k] = (u_.isFunction(opt[k]) ? opt[k] : function() {}).bind(this);
		delete opt[k];
	});
	
	callbacks.cb = function(err, res) {
		if(err) {
			return callbacks.error(err);
		} else {
			return callbacks.success(res);
		}
	};
	
	// ローダー表示関数の実行
	this.showLoading(methodName);
	
	if( this.$self.find([
		"input[type='file']",
		"input[type='image']"
	].join(",") ).length ) {
		// input[type="file"] or input[type="image"]がある場合はclone出来ないため、そのまま送信する
		if($form.attr("enctype") !== "multipart/form-data") {
			$form.attr({
				enctype: "multipart/form-data",
				encoding: "multipart/form-data"
			});
		}
	} else
	if(FormData) {
		//FormDataを使用できる場合はcloneしたフォームを送信する
		$form = this.$self.clone().addClass("is-clone");
	}
	
	if( $form.hasClass("is-clone") ) {
		// textarea, selectはclone()時にvalueがコピーされない
		$form.find("textarea, select").each((i, elm) => {
			!!elm.id && $(elm).replaceWith(
				$("<input/>").addClass(elm.className).attr({
					type: "hidden",
					name: elm.name,
					id: elm.id
				}).val(document.getElementById(elm.id).value)
			);
		});
	}
	
	const df = $.Deferred();
	
	// beginコールバックを実行
	$.when( callbacks.begin($form, opt) ).then(() => {
		var formData = !!FormData && new FormData( $form.get(0) );
		
		if(formData) {
			Object.assign(opt, {
				data: formData,
				processData: false,
				contentType: false,
			});
			
			return this._sendRequest(methodName, opt, callbacks.cb);
			
		} else {
			// for [LTE IE9]
			return this._aSubmitLegacy(methodName, opt, callbacks.cb);
		}
	}).always(() => {
		callbacks.complete($form);
		
		// ローダー非表示関数の実行
		this.hideLoading(methodName);
		df.resolve();
	});
	
	return df.promise();
}

export default aSubmit;
